var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.89 1.11a.375.375 0 00-.53 0L16 15.47 1.64 1.11a.375.375 0 10-.53.53L15.47 16 1.11 30.36a.375.375 0 10.53.53L16 16.53l14.36 14.36a.374.374 0 00.53 0 .375.375 0 000-.53L16.53 16 30.89 1.64a.375.375 0 000-.53z",
    fill: "#333",
    stroke: "#333",
    strokeWidth: 0.7
  })));
};

export default SvgClose;